(ns app.util.api-request
  "Utils to make an authenticated API request."
  (:require [cljs-http.client :as http]
            ))

(defn wrap-auth [client]
  (fn [request]
    (client (-> request
                ;; do not send credentials, so that the server does
                ;; not need to set the
                ;; Access-Control-Allow-Credentials CORS header:
                (assoc :with-credentials? false))
            )))

(def request
  (-> http/request
      (wrap-auth)))

(defn add-http-client
  "Adds `request` as `:http/client` to `w`. Thereby subsequent functions does not
   need to be coupled to this namespace or rather the `request` function here."
  [w]
  (assoc w
         :http/client
         request))
